import {
  faBan,
  faCoffee,
  faCreditCard,
  faMobileAlt,
  faTicketAlt,
  faUniversity,
  faWallet,
} from "@fortawesome/fontawesome-free-solid";

const PAYMENT_ICONS = {
  card: faCreditCard,
  wallet: faWallet,
  "apple pay": faMobileAlt,
  "google pay": faMobileAlt,
  bank: faUniversity,
  coupon: faTicketAlt,
  freecoffee: faCoffee,
  none: faBan,
};

const getPaymentIcon = (method) => {
  if (!method) return null;
  return PAYMENT_ICONS[method.toLowerCase()] || faCreditCard;
};

export default getPaymentIcon;
